import React from 'react'

// styles
import './abouthero.styles.css'

const Abouthero = () => {
  return (
    <div className='about-hero-container'>
        <h1>We are building <br/> you a home</h1>
        <p>in the world of crypto</p>
    </div>
  )
}

export default Abouthero;